/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean } from './common-D-vggmh2.js';

const validateSpellCheck = (component, value) => {
    watchBoolean(component, '_spellCheck', value, {
        defaultValue: undefined,
    });
};

export { validateSpellCheck as v };
//# sourceMappingURL=spell-check-6kYqpIpx.js.map

//# sourceMappingURL=spell-check-6kYqpIpx.js.map